/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Circle,
  Close,
  DoneAll,
  NotificationsActive,
  TagFaces,
} from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Tooltip,
} from "@mui/material";
import styles from "../Styles/mainHeader.module.css";
import { Fragment, useContext, useState } from "react";
import { Vocabulary } from "../Utils/Vocabulary";
import moment from "moment";
import { postData } from "../Services/postData";
import { urlEnum } from "../Utils/urlEnum";
import { NotificationsContext } from "../Context/notificationsContext";
//import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import ChecklistIcon from "@mui/icons-material/Checklist";

export default function Notifications() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const {
    notifications,
    notificationCount,
    getNotificationsForUser,
  }: {
    notifications: any[];
    notificationCount: number;
    getNotificationsForUser: () => void;
  } = useContext(NotificationsContext);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  /**
   *
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  /**
   *
   */
  const handleClose = (markAllAsRead = false) => {
    if (markAllAsRead) {
      postData(urlEnum.markAllNotificationsAsRead, {}).then((res: any) => {
        if (res) {
          getNotificationsForUser();
        }
      });
      setAnchorEl(null);
      return;
    }

    //set notifications to read
    //create array containing ids of the currently visible unread notifications
    const unreadNotifications = notifications
      .filter((notification) => !!notification.isRead === false)
      .map((notification) => notification.id);

    if (unreadNotifications.length > 0) {
      postData(urlEnum.markNotificationAsRead, {
        notificationsIds: unreadNotifications,
      }).then((res: any) => {
        if (res) {
          getNotificationsForUser();
        }
      });
    }
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label={Vocabulary.openNotifications}
        onClick={handleClick}
        sx={{ color: "#000", p: { xs: 1.5, sm: 1 } }}
      >
        <Badge
          badgeContent={notificationCount}
          max={100}
          classes={{ badge: styles.badge }}
        >
          <NotificationsActive />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleClose()}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card>
          <CardHeader
            subheader={Vocabulary.notifications}
            action={
              <>
                <Button
                  onClick={() => handleClose(true)}
                  startIcon={<ChecklistIcon />}
                  style={{ textTransform: "none" }}
                >
                  {Vocabulary.markAsRead}
                </Button>
                <IconButton
                  aria-label={Vocabulary.closeNotifications}
                  onClick={() => handleClose()}
                >
                  <Close />
                </IconButton>
              </>
            }
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "background.paper",
              zIndex: 1,
            }}
          />
          <CardContent sx={{ padding: 0, maxHeight: "80vh", overflowY: "auto" }}>
            <List>
              {notifications && notifications.length > 0 ? (
                notifications.map((notification: any) => {
                  return (
                    <Fragment key={notification.id}>
                      <Tooltip title={notification.message}>
                        <ListItem
                          className={`${
                            notification.isRead
                              ? styles.notificationRead
                              : styles.notificationNotRead
                          }`}
                        >
                          <ListItemAvatar
                            className={`${
                              notification.isRead
                                ? styles.messageRead
                                : styles.messageNotRead
                            }`}
                          >
                            {notification.isRead ? <DoneAll /> : <Circle />}
                          </ListItemAvatar>
                          <ListItemText
                            className={`${
                              notification.isRead
                                ? styles.messageRead
                                : styles.messageNotRead
                            }`}
                            primary={`${notification.message?.substring(
                              0,
                              50
                            )}...`}
                            secondary={moment(notification.created_at).format(
                              "DD-MM-YYYY HH:mm"
                            )}
                          />
                        </ListItem>
                      </Tooltip>
                      <Divider />
                    </Fragment>
                  );
                })
              ) : (
                <ListItem>
                  <ListItemText>{Vocabulary.noNotifications} </ListItemText>
                  <ListItemAvatar>
                    <TagFaces />
                  </ListItemAvatar>
                </ListItem>
              )}
            </List>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
}
